module.exports = __webpack_public_path__ + "img/shout.90f5cacd.png";